import React from 'react';
import VehicleForm from './VehicleForm.js';
export default function AddVehicleAnyUser() {
  return <VehicleForm />;
}
